export const DIRECTION_ARRIVE = "arrive";
export const DIRECTION_FLIGHT = "flight";

export const CARRIER_RYANAIR = "ryanair";
export const CARRIER_WIZZAIR = "wizzair";

export const DEPARTURE = "departure";
export const RETURN = "return";
